import Title from '@/components/InspectionReport/Items/Questions/Title';
import Response from '@/components/InspectionReport/Items/Questions/Response';
import ImageDrawing from '@/components/InspectionReport/Items/Questions/ImageDrawing';

export default {
    functional: true,
    props: {
        item: {
            type: Object,
            required: true,
        },
        resource: {
            type: Object,
            default: null,
        },
    },
    render(h, { props, data }) {
        let photoResponse = null;

        if (props.item.responded === true && props.item.response) {
            photoResponse = props.item.response.map((photo) => h(ImageDrawing, {
                class: ['mr-3 mb-3  inline-block'],
                style: 'max-height: 240px;',
                props: {
                    image: photo.image,
                    drawing: photo.drawing,
                },
            }));
        }

        return h(
            'div',
            data,
            [
                h(Title, {}, props.item.title),
                h(
                    Response,
                    { props: { responded: props.item.responded === true } },
                    photoResponse,
                ),
            ],
        );
    },
};
